import type { PolicyEntity } from '@/shared/entities/PolicyEntity'

export class CreateUpdateRoleEntity {
  name?: string | null
  policies?: Array<PolicyEntity> | null
}
